import React from 'react';
import StatusIndicator from './StatusIndicator';

const departments = [
  { name: 'Dev', color: 'bg-blue-500' },
  { name: 'Marketing', color: 'bg-green-500' },
  { name: 'Design', color: 'bg-purple-500' },
  { name: 'Research', color: 'bg-orange-500' },
  { name: 'Communication', color: 'bg-teal-500' },
  { name: 'Project', color: 'bg-red-500' },
  { name: 'Security', color: 'bg-gray-500' },
];

const Sidebar = () => {
  return (
    <aside className="w-64 bg-gray-900 border-r border-gray-800 flex flex-col h-full">
      <div className="p-6 border-b border-gray-800">
        <h1 className="text-xl font-bold text-white mb-2 tracking-tight">OmniBotAI</h1>
        <StatusIndicator />
      </div>

      <div className="flex-1 p-4">
        <h2 className="text-xs text-gray-500 uppercase tracking-widest font-bold mb-4 px-2">Departments</h2>
        <ul className="space-y-1">
          {departments.map((dept) => (
            <li key={dept.name}>
              <button className="w-full flex items-center gap-3 px-3 py-2 text-sm text-gray-300 hover:text-white hover:bg-gray-800 rounded-lg transition-colors group">
                <div className={`w-2 h-2 rounded-full ${dept.color} shadow-[0_0_8px_${dept.color}] opacity-70 group-hover:opacity-100`}></div>
                {dept.name}
              </button>
            </li>
          ))}
        </ul>
      </div>

      <div className="p-4 border-t border-gray-800">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-full bg-gray-700 flex items-center justify-center text-xs text-white">OP</div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-white truncate">Operator</p>
            <p className="text-xs text-gray-500 truncate">Tier 1 Access</p>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
